export default __webpack_public_path__ + "static/media/angsa.5b17e926.ttf";